<app-search-location-badge class="min-w-0" [type]="type()" [name]="title()" [color]="color() ?? undefined" />
